"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blenderCss = void 0;
const styled_components_1 = require("styled-components");
const typography_1 = require("@clds/typography");
const blender_1 = require("./blender");
const prefix = '--ds-foundations';
const typography = `${prefix}--typography`;
const variables = {
    typographyColor: `${typography}--color`,
    typographyFontWeight: `${typography}--font-weight`,
    backgroundColor: `${prefix}--background-color`,
    foregroundColor: `${prefix}--foreground-color`,
};
const populateVariables = (props) => (componentProps) => {
    const backgroundColor = (0, blender_1.blenderBackground)(Object.assign(Object.assign({}, props), componentProps));
    const foregroundColor = (0, blender_1.blenderForeground)(Object.assign(Object.assign({}, props), componentProps));
    const typographyType = (0, blender_1.getBlenderTypographyType)(props.mode, props.variant);
    const exampleTypographyRuleMixins = (0, typography_1.getTypographyRuleMixins)('xs', typographyType);
    return (0, styled_components_1.css) `
      ${variables.backgroundColor}: ${backgroundColor};
      ${variables.foregroundColor}: ${foregroundColor};
      ${variables.typographyColor}: ${exampleTypographyRuleMixins.color};
      ${variables.typographyFontWeight}: ${exampleTypographyRuleMixins.fontWeight};
    `;
};
const typographyFromCssVariables = (size) => (0, styled_components_1.css) `
  font-size: ${typography_1.appsTheme[size].size};
  line-height: ${typography_1.appsTheme[size].lineHeight};
  color: var(${variables.typographyColor});
  font-weight: var(${variables.typographyFontWeight});
`;
const backgroundFromCssVariables = `var(${variables.backgroundColor})`;
const foregroundFromCssVariables = `var(${variables.foregroundColor})`;
exports.blenderCss = {
    variables,
    populateVariables,
    typographyFromCssVariables,
    backgroundFromCssVariables,
    foregroundFromCssVariables,
};
//# sourceMappingURL=blenderCss.js.map